export default "__VITE_ASSET__fQjZFzPH__"